import { render, staticRenderFns } from "./EditPreview.vue?vue&type=template&id=1cba5ffc&scoped=true&"
import script from "./EditPreview.vue?vue&type=script&lang=js&"
export * from "./EditPreview.vue?vue&type=script&lang=js&"
import style0 from "./EditPreview.vue?vue&type=style&index=0&id=1cba5ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba5ffc",
  null
  
)

export default component.exports